import { toast } from 'react-toastify';
import axios from 'axios';
import * as types from '../constants/actionTypes';
import { request } from '../helpers/axiosRequest';
import { logUserActivity } from './activityLogsActions';

export const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

// Create Faq
export const createFaq = (data, navigate) => async (dispatch) => {
  try {
    dispatch({ type: types.CREATE_FAQS_ATTEMPT });
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/faq/add-faq`,
      auth: true,
      method: 'POST',
      data
    });
    toast.success('Faq Added Successsully', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    dispatch({
      type: types.CREATE_FAQS_SUCCESS,
      payload: { ...data }
    });
    dispatch(logUserActivity(`ADDED_FAQ`));
    setTimeout(() => {
      navigate('/dashboard/pages/faqs');
    }, 2000);
  } catch (err) {
    dispatch({ type: types.CREATE_FAQS_FAIL, payload: err });
    toast.error(err, {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    throw err;
  }
};

// Get Single FAQ
export const singleFaq = (slug) => async (dispatch) => {
  dispatch({ type: types.SINGLE_FAQS_ATTEMPT });
  try {
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/faq/get-faq-slug`,
      auth: true,
      method: 'POST',
      data: { country: slug }
    });
    dispatch({
      type: types.SINGLE_FAQS_SUCCESS,
      payload: res.data
    });
  } catch (err) {
    dispatch({ type: types.SINGLE_FAQS_FAIL, payload: err });
    throw err;
  }
};

// Update Faq
export const updateFaq = (data, navigate) => async (dispatch) => {
  try {
    dispatch({ type: types.UPDATE_FAQS_ATTEMPT });
    const res = await request({
      url: `${process.env.REACT_APP_API_URL}/faq/update-content/${data.country}`,
      auth: true,
      method: 'PUT',
      data
    });
    dispatch({
      type: types.UPDATE_FAQS_SUCCESS,
      payload: { ...data }
    });
    toast.success('Faqs Updated Successsully', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    dispatch(logUserActivity(`UPDATED_FAQ`));
    setTimeout(() => {
      navigate('/dashboard/pages/faqs');
    }, 2000);
  } catch (err) {
    dispatch({ type: types.UPDATE_FAQS_FAIL, payload: err });
    throw err;
  }
};

// Delete Faq
export const deleteFaq = (countrySlug) => async (dispatch) => {
  try {
    dispatch({ type: types.DELETE_MENU_ATTEMPT });
    const res = await request({
      method: 'DELETE',
      auth: true,
      url: `${process.env.REACT_APP_API_URL}/faq/delete-content`,
      data: { country: countrySlug }
    });

    toast.success('Faqs Content Deleted Successsully', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined
    });
    dispatch(logUserActivity(`DELETED_FAQ`));
    setTimeout(() => {
      window.location.href = '/dashboard/pages/faqs';
    }, 2000);

    dispatch({ type: types.DELETE_MENU_SUCCESS, payload: {} });
  } catch (err) {
    dispatch({ type: types.DELETE_MENU_FAIL, payload: err });
    throw new Error(err);
  }
};
